//import errorHandler from './errorHandler'
import api from '../../../api'
import _ from 'lodash'

export default {
    get : (query, next) => {
        api.get('/api/v1/workspaces?user='+ query, (err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, _.get(data, '[0].pages', []));
        })   
    },
    getInstagramAdAccounts : (query, next) => {
        api.get('/instagram/users/'+ query.userId + '/adaccounts', (err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, _.get(data, '[0].pages', []));
        })   
    },
    del : (payload, next) => {
        api.delete('/api/v1/workspaceusers/'+payload.query.workspaceUsersId+'/pages/'+ payload.query.pageId, (err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    create : (payload, next) => {
        api.post('/api/v1/pages', payload.body, (err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    setPageForGroup : (payload, next) => {
        api.post('/api/v1/tokens', payload.body, (err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    setPageParent : (payload, next) => {
        api.put('/api/v1/pages/' + payload.query.pageId + '/parent', payload.body, (err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    update : (payload, next) => {
        api.put('/api/v1/pages/' + payload.query.pageId, payload.body, (err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    setTag : (payload, next) => {
        api.put('/api/v1/pages/' + payload.query.pageId + '/tags', payload.body, (err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    deleteTag : (payload, next) => {
        api.delete('/api/v1/pages/' + payload.query.pageId + '/tags/' + payload.query.tagId, (err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    updateConfig : (payload, next) => {
        api.put('/api/v1/pages/' + payload.query.pageId + '/widgetConfig/',  payload.body, (err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    getConfig : (query, next) => {
        api.get('/api/v1/pages/' + query.pageId,(err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
} 



// WEBPACK FOOTER //
// ./src/libs/system/services/accounts.js